import { useEffect, useRef } from "react";
import { usePortalPageContext } from "context/PortalPageContext";

/** Publish live page filters/selection to the portal assistant. */
export function useRegisterAssistantPage(snapshot) {
  const { setPageContext } = usePortalPageContext();
  const serialized = snapshot ? JSON.stringify(snapshot) : "";
  const prevRef = useRef("");

  useEffect(() => {
    if (serialized === prevRef.current) return undefined;
    prevRef.current = serialized;
    setPageContext(snapshot || null);
    return () => setPageContext(null);
  }, [serialized, snapshot, setPageContext]);
}
